
import * as firebase from 'firebase'

const Utils = {
  getNewKey: (eventId, dateStr) => {
    const path = `events/${eventId}/extendedInfo/modules/reminders/${dateStr}/`
    return firebase.database().ref(path).push().key
  },

  saveReminder: (moduleType, moduleItemId, reminderId, creatorId, eventId, dateStr) => {
    const path = `events/${eventId}/extendedInfo/modules/reminders/${dateStr}/${reminderId}`
    const reminder = { moduleType, moduleItemId, creatorId, id : reminderId }
    return firebase.database().ref(path).set(reminder)
  },

  deleteReminder: (reminderId, eventId, dateStr) => {
    const path = `events/${eventId}/extendedInfo/modules/reminders/${dateStr}/${reminderId}/delete`
    return firebase.database().ref(path).set(true)
  },
}

export default Utils



// WEBPACK FOOTER //
// ./src/schedule/common/modules/reminders/ReminderInstanceUtils.js